import React from "react";
import { Box, Typography } from "@mui/material";
import { ProductStrategyContent } from "data/@types/GlobalSearchData";
import AppIcon from "ui/components/icons/AppIcon";
import { iconInventory2, iconExtension } from "ui/components/icons";
import GlobalSearchItemHeader from "./GlobalSearchItemHeader";
import DotDivider from "ui/components/data-display/DotDivider";
import useHighlight, { globalSearchMarkStyle } from "data/hooks/useHighlight";
import { useGlobalSearchContext } from "../SearchProvider";
import { valueOrPlaceholder } from "utils/form";

type ProductStrategyItemProps = {
  productStrategy: ProductStrategyContent;
};

const ProductStrategyItem = ({ productStrategy }: ProductStrategyItemProps) => {
  const { search } = useGlobalSearchContext();
  const { highlight } = useHighlight(search, globalSearchMarkStyle);

  return (
    <Box
      sx={{
        padding: "6px 0",
        display: "inline-grid",
        gridTemplateColumns: "25px auto",
        width: "100%",
        alignItems: "center",
      }}
    >
      {productStrategy.entityType === "Product" ? (
        <AppIcon
          icon={iconInventory2}
          sx={{
            fontSize: "1em",
            gridRow: "span 2",
            alignSelf: "start",
            transform: "translateY(3px)",
          }}
          data-test-id="product-icon"
        />
      ) : (
        <AppIcon
          icon={iconExtension}
          sx={{
            fontSize: "1em",
            gridRow: "span 2",
            alignSelf: "start",
            transform: "translateY(3px)",
          }}
          data-test-id="strategy-icon"
        />
      )}

      <GlobalSearchItemHeader
        entityType={productStrategy.entityType}
        firm={productStrategy.firm!}
        entity={{
          id:
            productStrategy.entityType === "Product"
              ? productStrategy.uniqueId
              : productStrategy.id,
          longName: productStrategy.longName,
        }}
      />

      <Typography
        sx={{
          fontSize: "11px",
          color: "text.secondary",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: `Asset Class: ${highlight(valueOrPlaceholder(productStrategy.assetClass))}`,
          }}
        />

        <DotDivider style={{ mx: 1 }} component="span" />

        <span
          dangerouslySetInnerHTML={{
            __html: `Rating: ${highlight(valueOrPlaceholder(productStrategy.rating))}`,
          }}
        />
      </Typography>
    </Box>
  );
};

export default ProductStrategyItem;
